import * as React from 'react'
import clsx from 'clsx'
import { Button, Card, Form, Paragraph, Select, Title } from 'components/common'
import { LedgerItemStatus } from 'lib/graphql/storeadmin'

export interface LedgerStatusProps {
  status?: LedgerItemStatus | string
  loading?: boolean
  onUnarchive: () => void
}

export const LedgerItemStatusCard = React.memo(
  ({
    status = LedgerItemStatus.Active,
    loading = false,
    onUnarchive,
  }: LedgerStatusProps): JSX.Element => (
    <Card shadow loading={loading}>
      <Title level={5}>ステータス</Title>

      {status !== LedgerItemStatus.Archived && (
        <Form.Item noStyle shouldUpdate>
          {() => (
            <Form.Item name="status" initialValue={status} noStyle>
              <Select style={{ width: '100%' }}>
                <Select.Option value={LedgerItemStatus.Active}>
                  アクティブ
                </Select.Option>
                <Select.Option value={LedgerItemStatus.Archived}>
                  アーカイブ
                </Select.Option>
              </Select>
            </Form.Item>
          )}
        </Form.Item>
      )}

      {status === LedgerItemStatus.Archived && (
        <div className={clsx('rounded-lg', 'bg-gray-100', 'p-8')}>
          <div
            className={clsx('flex', 'flex-col', 'flex-center', 'items-center')}
          >
            <Paragraph className={clsx('text-2xl')} strong>
              アーカイブ済み
            </Paragraph>
            <Paragraph>現金出納項目一覧以外では表示されません。</Paragraph>
            <Button onClick={onUnarchive}>アーカイブを解除する</Button>
          </div>
        </div>
      )}
    </Card>
  )
)
